var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "site-profile-form",
      on: {
        change: function ($event) {
          return _vm.formUtils.setDirty()
        },
      },
    },
    [
      _c("InputField", {
        attrs: {
          label: _vm.$t("settings.site.name"),
          showFlag: true,
          showColon: false,
          required: true,
          showEmptyDash: true,
          value: _vm.displaySite.code,
          readonly: true,
        },
        on: {
          updateValue: function (val) {
            return _vm.updateField("code", val)
          },
        },
      }),
      _vm._v(" "),
      _c("InputField", {
        attrs: {
          label: _vm.$t("settings.site.description"),
          showFlag: true,
          showColon: false,
          required: true,
          value: _vm.displaySite.note,
          readonly: !_vm.isEdit,
        },
        on: {
          updateValue: function (val) {
            return _vm.updateField("note", val)
          },
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "new-multiselect" },
        [
          _c(
            "label",
            { class: { emphasis: true, "required-flag": _vm.isEdit } },
            [_vm._v(_vm._s(_vm.$t("settings.site.type")))]
          ),
          _vm._v(" "),
          _vm.isEdit
            ? _c("HKLSelect", {
                attrs: {
                  value:
                    _vm.displaySite.type && _vm.displaySite.type.toUpperCase(),
                  options: _vm.siteTypeHklOptions,
                  dirtyCheck: true,
                  required: true,
                  showSearch: true,
                  placeholder: "",
                },
                on: {
                  change: function (val) {
                    return _vm.updateType(val)
                  },
                },
              })
            : _c("span", [
                _vm._v(_vm._s(_vm.customSiteTypeLabel(_vm.displaySite.type))),
              ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("label", { class: { emphasis: true, "required-flag": _vm.isEdit } }, [
        _vm._v(_vm._s(_vm.$t("settings.site.companyName"))),
      ]),
      _vm._v(" "),
      _vm.isEdit
        ? _c("TextField", {
            attrs: {
              value: _vm.displaySite.subsidiary,
              showColon: false,
              required: true,
            },
            on: {
              inputValue: function (val) {
                return _vm.updateField("subsidiary", val)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", {
        staticClass: "clearfix",
        domProps: {
          innerHTML: _vm._s(_vm.displaySite.subsidiary || _vm.$t("emptyValue")),
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "new-multiselect" },
        [
          _c(
            "label",
            { class: { emphasis: true, "required-flag": _vm.isEdit } },
            [_vm._v(_vm._s(_vm.$t("settings.site.buildings")))]
          ),
          _vm._v(" "),
          _vm.isEdit
            ? _c("HKLMultiSelect", {
                class: {
                  "multi-value": true,
                  "error-highlight":
                    _vm.isBuildingsEmpty("buildings") &&
                    _vm.checkState.buildings,
                },
                attrs: {
                  value: _vm.buildingCodes(_vm.updatedSite),
                  options: _vm.buildingHklOptions,
                  placeholder: "",
                  dirtyCheck: true,
                  showSearch: false,
                  showLabels: false,
                  required: true,
                },
                on: { change: _vm.updateSiteBuildings },
              })
            : _c("span", [_vm._v(_vm._s(_vm.showBuildings(_vm.updatedSite)))]),
        ],
        1
      ),
      _vm._v(" "),
      _c("SiteContacts", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isPhysicalSite,
            expression: "isPhysicalSite",
          },
        ],
        key: _vm.siteDetail.id,
        ref: "siteContacts",
        staticClass: "location-info u-sec-margin-bottom",
        attrs: { isEditable: _vm.isEdit, users: _vm.users },
      }),
      _vm._v(" "),
      _c("TextField", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isPhysicalSite,
            expression: "isPhysicalSite",
          },
        ],
        staticClass: "location-info__location",
        attrs: {
          showColon: false,
          label: _vm.$t("settings.building.location"),
          readonly: !_vm.isEdit,
          defaultEmpty: true,
          value: _vm.displaySite.officeLocation,
        },
        on: {
          updateValue: function (val) {
            return _vm.updateField("officeLocation", val)
          },
        },
      }),
      _vm._v(" "),
      _c("InputField", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isPhysicalSite,
            expression: "isPhysicalSite",
          },
        ],
        staticClass: "location-info__telephone",
        attrs: {
          showFlag: false,
          showColon: false,
          extendClass: "location-info__telephone--input",
          label: _vm.$t("settings.building.telephone"),
          readonly: !_vm.isEdit,
          showEmptyDash: true,
          value: _vm.displaySite.officeTelephone,
        },
        on: {
          updateValue: function (val) {
            return _vm.updateField("officeTelephone", val)
          },
        },
      }),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "signatures" },
        [
          _c("label", { staticClass: "emphasis" }, [
            _vm._v(_vm._s(_vm.$t("settings.tab.tenantSignature"))),
          ]),
          _vm._v(" "),
          _vm._l(_vm.displaySite.templates, function (signature, index) {
            return _c(
              "div",
              { key: index, staticClass: "signature" },
              [
                _vm.isEdit
                  ? _c(
                      "span",
                      {
                        staticClass: "delete-icon",
                        on: {
                          click: function ($event) {
                            return _vm.deleteSignature(index)
                          },
                        },
                      },
                      [_vm._v("✕")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("InputField", {
                  attrs: {
                    label:
                      _vm.$t("settings.site.signature") + " " + _vm.$t("name"),
                    value: signature.title,
                    readonly: !_vm.isEdit,
                    showColon: false,
                    required: true,
                  },
                  on: {
                    updateValue: function (val) {
                      return _vm.updateSignature("title", val, index)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "new-multiselect" },
                  [
                    _c(
                      "label",
                      {
                        class: { emphasis: true, "required-flag": _vm.isEdit },
                      },
                      [_vm._v(_vm._s(_vm.$t("settings.site.buildings")))]
                    ),
                    _vm._v(" "),
                    _vm.isEdit
                      ? _c("HKLMultiSelect", {
                          class: {
                            "multi-value": true,
                            "error-highlight":
                              _vm.isBuildingsEmpty(
                                "signatureBuildings",
                                index
                              ) && _vm.checkState.signatureBuildings[index],
                          },
                          attrs: {
                            value: _vm.buildingCodes(signature),
                            options: _vm.signatureBuildingHklOptions,
                            placeholder: "",
                            dirtyCheck: true,
                            showSearch: false,
                            showLabels: false,
                            required: true,
                          },
                          on: {
                            change: function (val) {
                              return _vm.updateSignatureBuildingCodes(
                                index,
                                val
                              )
                            },
                          },
                        })
                      : _c("span", [
                          _vm._v(_vm._s(_vm.showBuildings(signature))),
                        ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "label",
                  { class: { emphasis: true, "required-flag": _vm.isEdit } },
                  [_vm._v(_vm._s(_vm.$t("settings.site.signature")))]
                ),
                _vm._v(" "),
                _vm.isEdit
                  ? _c("TextField", {
                      attrs: {
                        value: signature.content,
                        showColon: false,
                        required: true,
                      },
                      on: {
                        inputValue: function (val) {
                          return _vm.updateSignature("content", val, index)
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", {
                  staticClass: "clearfix",
                  domProps: {
                    innerHTML: _vm._s(
                      signature.content || _vm.$t("emptyValue")
                    ),
                  },
                }),
              ],
              1
            )
          }),
          _vm._v(" "),
          _vm.isEdit
            ? _c(
                "div",
                {
                  staticClass: "add-signature",
                  on: {
                    click: function ($event) {
                      return _vm.addSignature()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("settings.site.addSignature")) +
                      " +\n    "
                  ),
                ]
              )
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }